import { Chip } from '@mui/material';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const preview = (value) => {
  const text = typeof value === 'string' ? value : JSON.stringify(value);
  if (!text || text === '{}' || text === 'null') return 'Empty';
  return text.length > 70 ? `${text.slice(0, 70)}…` : text;
};

const AdminSettingsPage = () => {
  const columns = [
    { key: 'key', label: 'Setting' },
    {
      key: 'value',
      label: 'Value',
      render: (row) => (
        <span style={{ fontFamily: 'var(--fuzzscan-ui-font-mono)', fontSize: 12, opacity: row.is_secret ? 0.6 : 1 }}>
          {row.is_secret ? 'Hidden (secret)' : preview(row.value)}
        </span>
      )
    },
    {
      key: 'is_active',
      label: 'Status',
      render: (row) =>
        row.is_active ? (
          <Chip size="small" label="Active" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="Inactive" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />
        )
    },
    {
      key: 'updated_at',
      label: 'Updated',
      render: (row) => (row.updated_at ? new Date(row.updated_at).toLocaleString() : '-')
    }
  ];

  const fields = [
    { name: 'key', label: 'Setting name', type: 'text', grid: 6 },
    { name: 'is_secret', label: 'Secret', type: 'switch', grid: 3 },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 3, defaultValue: true },
    { name: 'value', label: 'Value (JSON)', type: 'json', grid: 12, defaultJson: {} }
  ];

  return (
    <AdminResourceCrudPage
      title="Platform settings"
      subtitle="Values the platform reads while it runs. Secret values are hidden and stay as they are unless you replace them."
      icon={SettingsSuggestOutlinedIcon}
      endpoint="/api/admin/settings/"
      columns={columns}
      fields={fields}
    />
  );
};

export default AdminSettingsPage;
